import { createApp} from 'vue/dist/vue.esm-bundler'
import ListViewApp from './ListViewApp.vue'

import i18n from '/Modules/Translations/Admin/assets/js/I18n'

const keys = [
    'lists: download validated import',
    'lists: check list data',
    'lists: upload import',
    'lists: add founder',
    'lists: upload list items info',
    'lists: import template',
    'lists: no items found by filter',
    'lists: no items found by filter description',
    'filters: clear',
    'filters: clear filter',

    // 'lists: add new list item',
    'confirm: confirm item',
    'confirm:delete item',
    'upload or select files',
    'media: upload allowed types',
    'max file size',
    'lists: upload list items',
    'yes',
    'delete',
    'or',
    'lists: edit item',
    'lists: delete item',
    'lists: validation results',
    'lists: item no',
    'lists: item state',
    'lists: enter search fragment',
    'lists: loading items list',
    //'filter',
    'search',
    'total of',
    'items per page',
    'prev',
    'next',
    'actions title',

    'lists: items last check date',
    'application: project required members count',
    'application: project valid members count',

    'lists: failed to load data',
];

class ListInput {
    static init($context = null) {
        let selector = "[data-view='list']";
        let $containers = $context ? $context.find(selector) : $(selector);

        $containers.each(function (index, element) {
            if ($(element).data('list_view_instance')) return;
            const app = createApp(ListViewApp)


            app.config.globalProperties.basePath = function (params){
                if($('base').length){
                    return '';
                }else{
                    return '/'
                }
            }
            i18n.init(keys, app, function (){
                app.mount(element);
            }.bind(this), '/api/')
            $(element).data('list_view_instance', app)
        });
    }

}

ListInput.init()
export default ListInput;